/**
 * DVRs and XVRs (hybrid recorders accepting HDCVI/AHD/HD-TVI/CVBS + IP)
 * migrated from tools/camera-additions.json. Covers Hikvision Turbo HD
 * (DS-7204/7208/7216/7332 HQHI/HUHI K-series), Dahua Penta-brid XVR
 * (XVR1A04/XVR4104HS/XVR5108/XVR5216AN-I2), Uniview XVR301, Hanwha legacy
 * SRD/HRD/ZRD, Samsung 960H, Provision-ISR. All flagged hybrid: true.
 *
 * AUTO-GENERATED by tools/generate-migrated-catalogs.py from agent research
 * outputs in tools/equipment-research/. DO NOT edit by hand — re-run the
 * script if specs change. Generated on 2026-05-19.
 */
import type { EquipmentCatalogEntry } from './equipmentCatalogEntry';

export const MIGRATED_DVRS: EquipmentCatalogEntry[] = [
  {
    id: 'dahua-xvr5104h-4kl-i3-4p',
    manufacturer: 'Dahua',
    model: 'XVR5104H-4KL-I3-4P',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-4KL-I3-4P — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104H-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-4KL-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104H-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-i2',
    manufacturer: 'Dahua',
    model: 'XVR5104H-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-I2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-i',
    manufacturer: 'Dahua',
    model: 'XVR5104H-I',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-I — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-x',
    manufacturer: 'Dahua',
    model: 'XVR5104H-X',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-4kl-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104H-4KL-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-4KL-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104H-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-x1',
    manufacturer: 'Dahua',
    model: 'XVR5104H-X1',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-X1 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-4kl-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104H-4KL-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-4KL-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104h-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104H-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104H-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/PoC-Series/4K-N5MP-Series/XVR5104H-4KL-I3-4P',
    specs: {
      channels: 4,
      maxResolution: '4K (8 MP)',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-5m-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-5M-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-5M-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-4KL-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-x',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-X',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-i2',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-I2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-4kl-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-4KL-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-4KL-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-x1',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-X1',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-X1 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-4KL-I2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104hs-i22-e3-80-81technical',
    manufacturer: 'Dahua',
    model: 'XVR5104HS-I22%E3%80%81TECHNICAL',
    category: 'nvr-recorder',
    tagline: 'XVR5104HS-I22%E3%80%81TECHNICAL — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HS-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104C-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104C-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-4KL-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-x1',
    manufacturer: 'Dahua',
    model: 'XVR5104C-X1',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-X1 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-x',
    manufacturer: 'Dahua',
    model: 'XVR5104C-X',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-4kl-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104C-4KL-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-4KL-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104C-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-4kl-x',
    manufacturer: 'Dahua',
    model: 'XVR5104C-4KL-X',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-4KL-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-4kl-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104C-4KL-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-4KL-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104c-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104C-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104C-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104C-I3',
    specs: {
      channels: 4,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-4KL-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-5m-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-5M-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-5M-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-i2',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-I2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-4kl-i3-v2',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-4KL-I3=V2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-4KL-I3=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-I3=V3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-I3(1T)=V3.0-SSD1T — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108hs-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5108HS-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HS-4KL-I2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HS-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108H-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108H-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-4KL-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-4kl-i3-8p',
    manufacturer: 'Dahua',
    model: 'XVR5108H-4KL-I3-8P',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-4KL-I3-8P — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-4kl-i3-v2',
    manufacturer: 'Dahua',
    model: 'XVR5108H-4KL-I3=V2',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-4KL-I3=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5108H-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-I3=V3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-4kl-x-8p',
    manufacturer: 'Dahua',
    model: 'XVR5108H-4KL-X-8P',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-4KL-X-8P — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-i3-8p',
    manufacturer: 'Dahua',
    model: 'XVR5108H-I3-8P',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-I3-8P — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108h-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5108H-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5108H-I3(1T)=V3.0-SSD1T — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108H-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5216an-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5216AN-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5216AN-4KL-I3 — 16-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5216AN-4KL-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5216an-5m-i3',
    manufacturer: 'Dahua',
    model: 'XVR5216AN-5M-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5216AN-5M-I3 — 16-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5216AN-4KL-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5216an-4kl-i3-16p',
    manufacturer: 'Dahua',
    model: 'XVR5216AN-4KL-I3-16P',
    category: 'nvr-recorder',
    tagline: 'XVR5216AN-4KL-I3-16P — 16-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5216AN-4KL-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5216an-i3',
    manufacturer: 'Dahua',
    model: 'XVR5216AN-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5216AN-I3 — 16-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5216AN-4KL-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5216an-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5216AN-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5216AN-4KL-I2 — 16-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5216AN-4KL-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-4KL-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-4kl-i3-v2',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-4KL-I3=V2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-4KL-I3=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-I3=V3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-I3(1T)=V3.0-SSD1T — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-4KL-I2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108he-i2',
    manufacturer: 'Dahua',
    model: 'XVR5108HE-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5108HE-I2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108HE-4KL-I3',
    specs: {
      channels: 8,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-4KL-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-i2',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-I2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-i3',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-I3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-x',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-X',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-I3=V3 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-x1',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-X1',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-X1 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5104he-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5104HE-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5104HE-I3(1T)=V3.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5104HE-4KL-I3',
    specs: {
      channels: 4,
      maxResolution: '4K',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 3-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-v2',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I=V2',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-1t-v2-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I(1T)=V2.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I(1T)=V2.0-SSD1T — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-512g-v2-0-ssd',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I(512G)=V2.0-SSD',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I(512G)=V2.0-SSD — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-28512g-29-3dv2-0-ssd',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I%28512G%29%3DV2.0-SSD',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I%28512G%29%3DV2.0-SSD — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-5cn-5cndahua',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I%5CN%5CNDAHUA',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I%5CN%5CNDAHUA — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b08-i-5cn-5cnmusic',
    manufacturer: 'Dahua',
    model: 'XVR1B08-I%5CN%5CNMUSIC',
    category: 'nvr-recorder',
    tagline: 'XVR1B08-I%5CN%5CNMUSIC — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B08-I',
    specs: {
      channels: 8,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-i3',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-I3 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-5m-i3',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-5M-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-5M-I3 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-4KL-I2 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-4KL-I3 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-i3-v2',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-I3=V2',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-I3=V2 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5232an-i2',
    manufacturer: 'Dahua',
    model: 'XVR5232AN-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5232AN-I2 — 32-channel hybrid DVR/XVR, 2 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/au/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5232AN-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-i3',
    manufacturer: 'Dahua',
    model: 'XVR5816S-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-I3 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-4kl-i3-lp',
    manufacturer: 'Dahua',
    model: 'XVR5816S-4KL-I3-LP',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-4KL-I3-LP — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-i2',
    manufacturer: 'Dahua',
    model: 'XVR5816S-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-I2 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5816S-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-4KL-I3 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-4kl-i2-lp',
    manufacturer: 'Dahua',
    model: 'XVR5816S-4KL-I2-LP',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-4KL-I2-LP — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5816s-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5816S-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5816S-4KL-I2 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5816S-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5432l-i3',
    manufacturer: 'Dahua',
    model: 'XVR5432L-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5432L-I3 — 32-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5432L-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5432l-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5432L-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5432L-4KL-I3 — 32-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5432L-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5432l-i2',
    manufacturer: 'Dahua',
    model: 'XVR5432L-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5432L-I2 — 32-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5432L-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5432l-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5432L-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5432L-4KL-I2 — 32-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5432L-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5432l-x',
    manufacturer: 'Dahua',
    model: 'XVR5432L-X',
    category: 'nvr-recorder',
    tagline: 'XVR5432L-X — 32-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5432L-I3',
    specs: {
      channels: 32,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5832s-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5832S-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5832S-4KL-I3 — 32-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/4K-Value5MP-Series/XVR5832S-4KL-I3',
    specs: {
      channels: 32,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5832s-i3',
    manufacturer: 'Dahua',
    model: 'XVR5832S-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5832S-I3 — 32-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/4K-Value5MP-Series/XVR5832S-4KL-I3',
    specs: {
      channels: 32,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5832s-x',
    manufacturer: 'Dahua',
    model: 'XVR5832S-X',
    category: 'nvr-recorder',
    tagline: 'XVR5832S-X — 32-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/4K-Value5MP-Series/XVR5832S-4KL-I3',
    specs: {
      channels: 32,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5832s-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5832S-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5832S-4KL-I2 — 32-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/4K-Value5MP-Series/XVR5832S-4KL-I3',
    specs: {
      channels: 32,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5832s-i2',
    manufacturer: 'Dahua',
    model: 'XVR5832S-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5832S-I2 — 32-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/4K-Value5MP-Series/XVR5832S-4KL-I3',
    specs: {
      channels: 32,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr7816s-4k-i3',
    manufacturer: 'Dahua',
    model: 'XVR7816S-4K-I3',
    category: 'nvr-recorder',
    tagline: 'XVR7816S-4K-I3 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/4K-series/XVR7816S-4K-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr7816s-4kl-x',
    manufacturer: 'Dahua',
    model: 'XVR7816S-4KL-X',
    category: 'nvr-recorder',
    tagline: 'XVR7816S-4KL-X — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/4K-series/XVR7816S-4K-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr7816s-4k-i2',
    manufacturer: 'Dahua',
    model: 'XVR7816S-4K-I2',
    category: 'nvr-recorder',
    tagline: 'XVR7816S-4K-I2 — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/4K-series/XVR7816S-4K-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr7816s-4kl-x-lp',
    manufacturer: 'Dahua',
    model: 'XVR7816S-4KL-X-LP',
    category: 'nvr-recorder',
    tagline: 'XVR7816S-4KL-X-LP — 16-channel hybrid DVR/XVR, 8 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.dahuasecurity.com/products/All-Products/HDCVI-Recorders/4K-series/XVR7816S-4K-I3',
    specs: {
      channels: 16,
      maxResolution: '4K (8 MP)',
      hddBays: 8,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '2U',
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5416l-i3',
    manufacturer: 'Dahua',
    model: 'XVR5416L-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5416L-I3 — 16-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5416L-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5416l-4kl-i3',
    manufacturer: 'Dahua',
    model: 'XVR5416L-4KL-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5416L-4KL-I3 — 16-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5416L-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5416l-i2',
    manufacturer: 'Dahua',
    model: 'XVR5416L-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5416L-I2 — 16-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5416L-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5416l-4kl-i2',
    manufacturer: 'Dahua',
    model: 'XVR5416L-4KL-I2',
    category: 'nvr-recorder',
    tagline: 'XVR5416L-4KL-I2 — 16-channel hybrid DVR/XVR, 4 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/5MP-Value1080p-Series/XVR5416L-I3',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 4,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      alarmIO: '16-in / 6-out',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4104hs-i',
    manufacturer: 'Dahua',
    model: 'XVR4104HS-I',
    category: 'nvr-recorder',
    tagline: 'XVR4104HS-I — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4104HS-I',
    specs: {
      channels: 4,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4104hs-x',
    manufacturer: 'Dahua',
    model: 'XVR4104HS-X',
    category: 'nvr-recorder',
    tagline: 'XVR4104HS-X — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4104HS-I',
    specs: {
      channels: 4,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4104hs-i-v2',
    manufacturer: 'Dahua',
    model: 'XVR4104HS-I=V2',
    category: 'nvr-recorder',
    tagline: 'XVR4104HS-I=V2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4104HS-I',
    specs: {
      channels: 4,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4104hs-x1',
    manufacturer: 'Dahua',
    model: 'XVR4104HS-X1',
    category: 'nvr-recorder',
    tagline: 'XVR4104HS-X1 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4104HS-I',
    specs: {
      channels: 4,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b04-i',
    manufacturer: 'Dahua',
    model: 'XVR1B04-I',
    category: 'nvr-recorder',
    tagline: 'XVR1B04-I — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B04-I',
    specs: {
      channels: 4,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b04-i-v2',
    manufacturer: 'Dahua',
    model: 'XVR1B04-I=V2',
    category: 'nvr-recorder',
    tagline: 'XVR1B04-I=V2 — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B04-I',
    specs: {
      channels: 4,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b04-i-1t-v2-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR1B04-I(1T)=V2.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR1B04-I(1T)=V2.0-SSD1T — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B04-I',
    specs: {
      channels: 4,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr1b04-i-512g-v2-0-ssd',
    manufacturer: 'Dahua',
    model: 'XVR1B04-I(512G)=V2.0-SSD',
    category: 'nvr-recorder',
    tagline: 'XVR1B04-I(512G)=V2.0-SSD — 4-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/Cooper-I-Series/XVR1B04-I',
    specs: {
      channels: 4,
      maxResolution: '1080p (2 MP)',
      hddBays: 1,
      hddBayMaxTb: 6,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108c-i3',
    manufacturer: 'Dahua',
    model: 'XVR5108C-I3',
    category: 'nvr-recorder',
    tagline: 'XVR5108C-I3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108C-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108c-i3-v3',
    manufacturer: 'Dahua',
    model: 'XVR5108C-I3=V3',
    category: 'nvr-recorder',
    tagline: 'XVR5108C-I3=V3 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108C-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108c-i3-v3-0a',
    manufacturer: 'Dahua',
    model: 'XVR5108C-I3=V3%0A',
    category: 'nvr-recorder',
    tagline: 'XVR5108C-I3=V3%0A — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108C-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr5108c-i3-1t-v3-0-ssd1t',
    manufacturer: 'Dahua',
    model: 'XVR5108C-I3(1T)=V3.0-SSD1T',
    category: 'nvr-recorder',
    tagline: 'XVR5108C-I3(1T)=V3.0-SSD1T — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/Discontinued-Products/HDCVI-Recorders/XVR5108C-I3',
    specs: {
      channels: 8,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108hs-i',
    manufacturer: 'Dahua',
    model: 'XVR4108HS-I',
    category: 'nvr-recorder',
    tagline: 'XVR4108HS-I — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108HS-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108hs-x',
    manufacturer: 'Dahua',
    model: 'XVR4108HS-X',
    category: 'nvr-recorder',
    tagline: 'XVR4108HS-X — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108HS-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108hs-i-v2',
    manufacturer: 'Dahua',
    model: 'XVR4108HS-I=V2',
    category: 'nvr-recorder',
    tagline: 'XVR4108HS-I=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108HS-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108hs-x1',
    manufacturer: 'Dahua',
    model: 'XVR4108HS-X1',
    category: 'nvr-recorder',
    tagline: 'XVR4108HS-X1 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108HS-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108c-i',
    manufacturer: 'Dahua',
    model: 'XVR4108C-I',
    category: 'nvr-recorder',
    tagline: 'XVR4108C-I — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108C-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108c-x',
    manufacturer: 'Dahua',
    model: 'XVR4108C-X',
    category: 'nvr-recorder',
    tagline: 'XVR4108C-X — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108C-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108c-x1',
    manufacturer: 'Dahua',
    model: 'XVR4108C-X1',
    category: 'nvr-recorder',
    tagline: 'XVR4108C-X1 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108C-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'dahua-xvr4108c-i-v2',
    manufacturer: 'Dahua',
    model: 'XVR4108C-I=V2',
    category: 'nvr-recorder',
    tagline: 'XVR4108C-I=V2 — 8-channel hybrid DVR/XVR, 1 HDD (HDCVI, AHD, HD-TVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.dahuasecurity.com/be/products/All-Products/HDCVI-Recorders/1080N720p-Series/XVR4108C-I',
    specs: {
      channels: 8,
      maxResolution: '1080N / 720p',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265+', 'H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: 'Motion / video loss / tampering',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1673du',
    manufacturer: 'Hanwha',
    model: 'SRD-1673DU',
    category: 'nvr-recorder',
    tagline: 'SRD-1673DU — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1630d',
    manufacturer: 'Hanwha',
    model: 'SRD-1630D',
    category: 'nvr-recorder',
    tagline: 'SRD-1630D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1650dc',
    manufacturer: 'Hanwha',
    model: 'SRD-1650DC',
    category: 'nvr-recorder',
    tagline: 'SRD-1650DC — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1650du',
    manufacturer: 'Hanwha',
    model: 'SRD-1650DU',
    category: 'nvr-recorder',
    tagline: 'SRD-1650DU — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1653d',
    manufacturer: 'Hanwha',
    model: 'SRD-1653D',
    category: 'nvr-recorder',
    tagline: 'SRD-1653D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1656d',
    manufacturer: 'Hanwha',
    model: 'SRD-1656D',
    category: 'nvr-recorder',
    tagline: 'SRD-1656D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1670dc',
    manufacturer: 'Hanwha',
    model: 'SRD-1670DC',
    category: 'nvr-recorder',
    tagline: 'SRD-1670DC — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1673d',
    manufacturer: 'Hanwha',
    model: 'SRD-1673D',
    category: 'nvr-recorder',
    tagline: 'SRD-1673D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1676d',
    manufacturer: 'Hanwha',
    model: 'SRD-1676D',
    category: 'nvr-recorder',
    tagline: 'SRD-1676D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-470d',
    manufacturer: 'Hanwha',
    model: 'SRD-470D',
    category: 'nvr-recorder',
    tagline: 'SRD-470D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-473d',
    manufacturer: 'Hanwha',
    model: 'SRD-473D',
    category: 'nvr-recorder',
    tagline: 'SRD-473D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-476d',
    manufacturer: 'Hanwha',
    model: 'SRD-476D',
    category: 'nvr-recorder',
    tagline: 'SRD-476D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-480d',
    manufacturer: 'Hanwha',
    model: 'SRD-480D',
    category: 'nvr-recorder',
    tagline: 'SRD-480D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1680d',
    manufacturer: 'Hanwha',
    model: 'SRD-1680D',
    category: 'nvr-recorder',
    tagline: 'SRD-1680D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1694u',
    manufacturer: 'Hanwha',
    model: 'SRD-1694U',
    category: 'nvr-recorder',
    tagline: 'SRD-1694U — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1652d',
    manufacturer: 'Hanwha',
    model: 'SRD-1652D',
    category: 'nvr-recorder',
    tagline: 'SRD-1652D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-1654d',
    manufacturer: 'Hanwha',
    model: 'SRD-1654D',
    category: 'nvr-recorder',
    tagline: 'SRD-1654D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-880d',
    manufacturer: 'Hanwha',
    model: 'SRD-880D',
    category: 'nvr-recorder',
    tagline: 'SRD-880D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-876d',
    manufacturer: 'Hanwha',
    model: 'SRD-876D',
    category: 'nvr-recorder',
    tagline: 'SRD-876D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-873d',
    manufacturer: 'Hanwha',
    model: 'SRD-873D',
    category: 'nvr-recorder',
    tagline: 'SRD-873D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-870dc',
    manufacturer: 'Hanwha',
    model: 'SRD-870DC',
    category: 'nvr-recorder',
    tagline: 'SRD-870DC — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-852d',
    manufacturer: 'Hanwha',
    model: 'SRD-852D',
    category: 'nvr-recorder',
    tagline: 'SRD-852D — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-srd-850dc',
    manufacturer: 'Hanwha',
    model: 'SRD-850DC',
    category: 'nvr-recorder',
    tagline: 'SRD-850DC — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/srd-1673du/',
    specs: {
      channels: 16,
      maxResolution: '1080p',
      hddBays: 8,
      hddBayMaxTb: 8,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-1621-4t',
    manufacturer: 'Hanwha',
    model: 'HRX-1621-4T',
    category: 'nvr-recorder',
    tagline: 'HRX-1621-4T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-1620-4t',
    manufacturer: 'Hanwha',
    model: 'HRX-1620-4T',
    category: 'nvr-recorder',
    tagline: 'HRX-1620-4T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-821-3t',
    manufacturer: 'Hanwha',
    model: 'HRX-821-3T',
    category: 'nvr-recorder',
    tagline: 'HRX-821-3T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-820-3t',
    manufacturer: 'Hanwha',
    model: 'HRX-820-3T',
    category: 'nvr-recorder',
    tagline: 'HRX-820-3T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-421-2t',
    manufacturer: 'Hanwha',
    model: 'HRX-421-2T',
    category: 'nvr-recorder',
    tagline: 'HRX-421-2T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-1635-4t',
    manufacturer: 'Hanwha',
    model: 'HRX-1635-4T',
    category: 'nvr-recorder',
    tagline: 'HRX-1635-4T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-1634-4t',
    manufacturer: 'Hanwha',
    model: 'HRX-1634-4T',
    category: 'nvr-recorder',
    tagline: 'HRX-1634-4T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-835a-3t',
    manufacturer: 'Hanwha',
    model: 'HRX-835A-3T',
    category: 'nvr-recorder',
    tagline: 'HRX-835A-3T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-835-3t',
    manufacturer: 'Hanwha',
    model: 'HRX-835-3T',
    category: 'nvr-recorder',
    tagline: 'HRX-835-3T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-435-2t',
    manufacturer: 'Hanwha',
    model: 'HRX-435-2T',
    category: 'nvr-recorder',
    tagline: 'HRX-435-2T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-434-2t',
    manufacturer: 'Hanwha',
    model: 'HRX-434-2T',
    category: 'nvr-recorder',
    tagline: 'HRX-434-2T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-420-2t',
    manufacturer: 'Hanwha',
    model: 'HRX-420-2T',
    category: 'nvr-recorder',
    tagline: 'HRX-420-2T — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-835a',
    manufacturer: 'Hanwha',
    model: 'HRX-835A',
    category: 'nvr-recorder',
    tagline: 'HRX-835A — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrx-435l',
    manufacturer: 'Hanwha',
    model: 'HRX-435L',
    category: 'nvr-recorder',
    tagline: 'HRX-435L — 16-channel hybrid DVR/XVR, 8 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/hrx-1621-4t/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 8,
      hddBayMaxTb: 6,
      codecs: ['H.265', 'H.264', 'MJPEG'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrd-e1630l',
    manufacturer: 'Hanwha',
    model: 'HRD-E1630L',
    category: 'nvr-recorder',
    tagline: 'HRD-E1630L — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/hrd-e1630l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrd-e830l',
    manufacturer: 'Hanwha',
    model: 'HRD-E830L',
    category: 'nvr-recorder',
    tagline: 'HRD-E830L — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/hrd-e1630l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-hrd-e430l',
    manufacturer: 'Hanwha',
    model: 'HRD-E430L',
    category: 'nvr-recorder',
    tagline: 'HRD-E430L — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/hrd-e1630l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 2,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: 'desktop',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-zrd-e1620l',
    manufacturer: 'Hanwha',
    model: 'ZRD-E1620L',
    category: 'nvr-recorder',
    tagline: 'ZRD-E1620L — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/zrd-e1620l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 8,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-zrd-e820l',
    manufacturer: 'Hanwha',
    model: 'ZRD-E820L',
    category: 'nvr-recorder',
    tagline: 'ZRD-E820L — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/zrd-e1620l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 8,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-zrd-e420l',
    manufacturer: 'Hanwha',
    model: 'ZRD-E420L',
    category: 'nvr-recorder',
    tagline: 'ZRD-E420L — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/en/products/video-recorder/dvr/dvr-ch16/zrd-e1620l/',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 8,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-sdr-c5300',
    manufacturer: 'Hanwha',
    model: 'SDR-C5300',
    category: 'nvr-recorder',
    tagline: 'SDR-C5300 — 4-channel hybrid DVR/XVR, 1 HDD (AHD, CVBS)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/sdr-c5300/',
    specs: {
      channels: 4,
      maxResolution: '720p',
      hddBays: 1,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'hanwha-sdr-b3300',
    manufacturer: 'Hanwha',
    model: 'SDR-B3300',
    category: 'nvr-recorder',
    tagline: 'SDR-B3300 — 4-channel hybrid DVR/XVR, 1 HDD (AHD, CVBS)',
    verified: false,
    datasheetUrl: 'https://www.hanwhavision.com/ko/products/video-recorder/dvr/dvr-ch16/sdr-c5300/',
    specs: {
      channels: 4,
      maxResolution: '720p',
      hddBays: 1,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: 'N/A',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-16q3',
    manufacturer: 'Uniview',
    model: 'XVR301-16Q3',
    category: 'nvr-recorder',
    tagline: 'XVR301-16Q3 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-04u3-p4',
    manufacturer: 'Uniview',
    model: 'XVR301-04U3-P4',
    category: 'nvr-recorder',
    tagline: 'XVR301-04U3-P4 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-04u3',
    manufacturer: 'Uniview',
    model: 'XVR301-04U3',
    category: 'nvr-recorder',
    tagline: 'XVR301-04U3 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-08u3',
    manufacturer: 'Uniview',
    model: 'XVR301-08U3',
    category: 'nvr-recorder',
    tagline: 'XVR301-08U3 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-04g3',
    manufacturer: 'Uniview',
    model: 'XVR301-04G3',
    category: 'nvr-recorder',
    tagline: 'XVR301-04G3 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-04q3',
    manufacturer: 'Uniview',
    model: 'XVR301-04Q3',
    category: 'nvr-recorder',
    tagline: 'XVR301-04Q3 — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr301-04f',
    manufacturer: 'Uniview',
    model: 'XVR301-04F',
    category: 'nvr-recorder',
    tagline: 'XVR301-04F — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/1HDD/XVR301-16Q3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 1,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr302-16u3',
    manufacturer: 'Uniview',
    model: 'XVR302-16U3',
    category: 'nvr-recorder',
    tagline: 'XVR302-16U3 — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/2HDD/XVR302-16U3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr302-08u3',
    manufacturer: 'Uniview',
    model: 'XVR302-08U3',
    category: 'nvr-recorder',
    tagline: 'XVR302-08U3 — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/2HDD/XVR302-16U3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr302-32q3',
    manufacturer: 'Uniview',
    model: 'XVR302-32Q3',
    category: 'nvr-recorder',
    tagline: 'XVR302-32Q3 — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/2HDD/XVR302-16U3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'uniview-xvr302-16q3',
    manufacturer: 'Uniview',
    model: 'XVR302-16Q3',
    category: 'nvr-recorder',
    tagline: 'XVR302-16Q3 — 16-channel hybrid DVR/XVR, 2 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: true,
    datasheetUrl: 'http://sgcdn.uniview.com/Products/Digital_Video_Recorders/Digital_Video_Recorders/2HDD/XVR302-16U3/',
    specs: {
      channels: 16,
      maxResolution: '8 MP',
      hddBays: 2,
      hddBayMaxTb: 16,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '8-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1610d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1610D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1610D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1630d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1630D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1630D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1650dc-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1650DC.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1650DC.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1652d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1652D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1652D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1670dc-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1670DC.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1670DC.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-470d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-470D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-470D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-480d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-480D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-480D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-830d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-830D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-830D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-850dc-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-850DC.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-850DC.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-852d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-852D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-852D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-870dc-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-870DC.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-870DC.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1656d-beyond-series-dvr-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1656D-BEYOND-SERIES-DVR.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1656D-BEYOND-SERIES-DVR.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1676d-beyond-series-dvr-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1676D-BEYOND-SERIES-DVR.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1676D-BEYOND-SERIES-DVR.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-476d-beyond-series-dvr-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-476D-BEYOND-SERIES-DVR.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-476D-BEYOND-SERIES-DVR.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-876d-beyond-series-dvr-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-876D-BEYOND-SERIES-DVR.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-876D-BEYOND-SERIES-DVR.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1653d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1653D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1653D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1673d-aspx',
    manufacturer: 'Samsung',
    model: 'SRD-1673D.ASPX',
    category: 'nvr-recorder',
    tagline: 'SRD-1673D.ASPX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1610d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-1610D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-1610D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1652d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-1652D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-1652D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1670dc-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-1670DC.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-1670DC.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-1676d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-1676D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-1676D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-440d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-440D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-440D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-443d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-443D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-443D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-470d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-470D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-470D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-476d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-476D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-476D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'samsung-srd-480d-ashx',
    manufacturer: 'Samsung',
    model: 'SRD-480D.ASHX',
    category: 'nvr-recorder',
    tagline: 'SRD-480D.ASHX — 16-channel hybrid DVR/XVR, 4 HDD (CVBS)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://www.samsung-security.com/en/products/video-recording-and-management/dvr/16-channel/SRD-1610D.aspx',
    specs: {
      channels: 16,
      maxResolution: '960H / 4CIF',
      hddBays: 4,
      hddBayMaxTb: 4,
      codecs: ['H.264'],
      formFactor: '1U',
      alarmIO: '16-in / 4-out',
      hybrid: true,
    },
  },
  {
    id: 'provision-isr-sh-16200a5n-8l-1u-detail',
    manufacturer: 'Provision-ISR',
    model: 'SH-16200A5N-8L-1U-DETAIL',
    category: 'nvr-recorder',
    tagline: 'SH-16200A5N-8L-1U-DETAIL — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://provision-isr.com/product/ahd/dvr/16ch/sh-16200a5n-8l-1u-detail',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'provision-isr-sh-32400a5n-5l-1-5u-detail',
    manufacturer: 'Provision-ISR',
    model: 'SH-32400A5N-5L-1-5U-DETAIL',
    category: 'nvr-recorder',
    tagline: 'SH-32400A5N-5L-1-5U-DETAIL — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://provision-isr.com/product/ahd/dvr/16ch/sh-16200a5n-8l-1u-detail',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
  {
    id: 'provision-isr-sh-8100a5n-8l-1u-v2-detail',
    manufacturer: 'Provision-ISR',
    model: 'SH-8100A5N-8L-1U-V2-DETAIL',
    category: 'nvr-recorder',
    tagline: 'SH-8100A5N-8L-1U-V2-DETAIL — 16-channel hybrid DVR/XVR, 1 HDD (AHD, HD-TVI, HDCVI, CVBS, IP)',
    verified: false,
    datasheetUrl: 'https://web.archive.org/web/2024/https://provision-isr.com/product/ahd/dvr/16ch/sh-16200a5n-8l-1u-detail',
    specs: {
      channels: 16,
      maxResolution: '5 MP',
      hddBays: 1,
      hddBayMaxTb: 10,
      codecs: ['H.265', 'H.264'],
      formFactor: '1U',
      alarmIO: '4-in / 1-out',
      hybrid: true,
    },
  },
];
